export default {
  "meeting": {
    applyrecurring: 'Perubahan akan diterapkan pada jadwal berulang yang baru. Rapat sebelumnya tidak akan terpengaruh.',
    recurrenceDescribeTwo: 'Terjadi setiap {loopPulse} minggu pada {week}, mulai {start} hingga {end}',
    wanttodeletethemeetingfollowTwo: 'Hapus rapat yang dipilih dan semua rapat berulang berikutnya?',
    loopCycleSelectTips: 'Silakan pilih hari dalam seminggu untuk mengulang.',

    export: 'Ekspor',
    exportMeetingFileFuncTipsTitle: 'Konfirmasi Ekspor',
    exportMeetingFileFuncTipsContentOne: 'Tidak ada filter yang diterapkan. Sistem akan mengekspor catatan rapat tahun berjalan secara default.',
    exportMeetingFileFuncTipsContentTwo: 'Untuk mengekspor rapat dari periode waktu lain, silakan terapkan filter yang diinginkan sebelum mengekspor.',

    myMeetingSearch: 'Rapat Saya',
    meetingTimeSearch: 'Waktu Rapat',
    meetingRoomsSearch: 'Ruang Rapat',

    Recurring: 'Berulang:',
    wanttodeletethemeetingfollow: 'Apakah Anda yakin ingin menghapus rapat ini dan semua rapat berikutnya?',
    endTimeCannotBeforeBeginTime: 'Tanggal akhir tidak boleh lebih awal dari tanggal mulai',
    Thismeeting: 'Rapat ini',
    Recurringmeeting: 'Rapat berulang',
    Checkin: 'Check-in:',
    checkinTip: 'Setelah diaktifkan, peserta dapat melakukan check-in dengan memindai kode QR Penjadwal Ruangan.',
    Recurrence_Setrecurrence: 'Atur pengulangan',
    Recurrence_Start: 'Mulai',
    Recurrence_RepeatEvery: 'Ulangi setiap',
    Recurrence_Week: 'Minggu',
    Recurrence_end: 'Akhir',
    recurrenceDescribe: 'Terjadi setiap {week} mulai {start} hingga {end}',
    Recurrence_DoesnotRepeat: 'Tidak berulang',
    Recurrence_Weekly: 'Mingguan',

    AddressBookUser: 'Pengguna',
    AddressBookPhonebook: 'Buku alamat',

    RoomByPeopleNum1: '2 orang atau kurang',
    RoomByPeopleNum2: '3-6 orang',
    RoomByPeopleNum3: '7-10 orang',
    RoomByPeopleNum4: '11-15 orang',
    RoomByPeopleNum5: '16-20 orang',
    RoomByPeopleNum6: '21-30 orang',
    RoomByPeopleNum7: 'Lebih dari 30 orang',

    whoAreBound: 'Pengguna yang terhubung dengan akun sistem akan melihat rapat di kalender sistem. Pengguna yang mengisi email akan menerima notifikasi melalui email. Untuk menerima notifikasi, lengkapi informasi di [Profil Saya].',

    AttendessMeeting: 'Peserta:',
    SelectAttendessMeetingTip: 'Pilih peserta',

    MeetingFilter: 'Filter rapat',
    HostedbyMe: 'Saya sebagai penyelenggara',
    Invitedby: 'Saya diundang',
    Otherby: 'Lainnya',

    "AddressIsDuplicated": "Email kontak duplikat",
    "meetingExpired": "Kedaluwarsa",
    titlePhoneFormat: 'Telepon hanya dapat diisi angka, () + dan -.',
    "selectField": "Silakan pilih file",
    "Limit255": "Nama file tidak boleh lebih dari 255 karakter",
    "nameLimit25": "Nama tidak boleh lebih dari 25 karakter",
    "emailLimit50": "Email tidak boleh lebih dari 50 karakter",
    "emailFormatError": "Silakan masukkan alamat email yang valid",
    "phoneLimit11": "Nomor telepon dapat berisi hingga 11 digit",
    "ParticipantsEmail": "Email peserta:",
    "listIsEmpty": "Daftar kosong",
    "Startimporting": "Mulai Unggah",
    "Selectfile": "Pilih File",
    "Importfile": "Impor File",
    "ImportfileTip": "*Hanya file CSV berformat Outlook (.csv) atau vCard (.vcf) yang didukung untuk impor.",
    "addParticipants": "Tambah Peserta",
    "multiselectdeselect": "Petunjuk hapus tag",
    "multiselectselected": "Petunjuk terpilih",
    "enterOrSelectALabel": "Pilih email peserta",
    "deleTitleContact": "Apakah Anda yakin ingin menghapus kontak ini?",
    "delTitleContactContent": "Hapus kontak?",
    "deleteContactTitle": "Silakan pilih kontak yang ingin dihapus",
    "editcontact": "Edit Kontak",
    "Name": "Nama",
    "email": "Email",
    "telephoneNumber": "Telepon",
    "Addcontact": "Tambah Kontak",
    "Importcontactfile": "Impor Kontak",
    "AddressBook": "Buku Alamat",
    "Participants": "Peserta:",

    bindTipContent:"Organisasi ini sudah mengikat kalender pihak ketiga. Harap jadwalkan rapat melalui Outlook/Teams.",
    Productupdatenews: 'Pembaruan versi baru telah dirilis. ',
    bookingPerson: 'Dipesan oleh',
    "DeleteMeeting": "Hapus Rapat",
    "wanttodeletethemeeting": "Apakah Anda ingin menghapus rapat?",
    "hasbeendeleted": "Rapat telah dihapus",
    "theMeetingWasAborted": "Akhiri rapat lebih awal",
    "theMeetingWasAbortedContent": "Apakah Anda ingin mengakhiri rapat lebih awal?",
    "determineTheAbortTask": "Akhiri rapat lebih awal",
    "theMeetingEndedEarly": "Rapat telah diakhiri lebih awal.",
    "with": "dengan",
    "Other": "Lainnya",
    "tasks": "konflik tugas",
    "conflict": "Waktu rapat berikut ini bertentangan:",
    "meetConflicts": "Waktu yang lalu tidak dapat dipilih",
    "itIsNotAllowedToSelectThePastTime": "Terpilih",
    "selected": "Pilih tidak lebih dari 5 ruang rapat",
    "noOverFive": "Pendapat persetujuan",
    "approvalOpinions": "Di luar batas waktu, tidak dapat dipilih",
    "beyondTheTimeLimitItCannotBeSelected": "Bulan mulai",
    "startMonth": "hingga",
    "to": "Bulan akhir",
    "stopMonth": "Tanpa mulai",
    "didnTStart": "Sedang berlangsung",
    "ONGOING": "Selesai",
    "ENDED": "telah",
    "hasBeen": "pemesanan",
    "booking": "Persetujuan",
    "Approval": "Ruang rapat",
    "MeetingRoom": "Semua ruang",
    "AllRoom": "Tersedia",
    "Available": "Mulai rapat",
    "Initiate": "Persetujuan rapat",
    "MeetingApproval": "Bulan sebelumnya",
    "PreviousMonth": "Hari ini",
    "Today": "Bulan berikutnya",
    "NextMonth": "Tahun/Bulan",
    "YearMonth": "Tampilan waktu",
    "TimeDisplay": "Singkatan judul rapat",
    "MeetingTitleAbbreviation": "Mulai rapat",
    "InitiateMeeting": "Rapat yang akan datang",
    "PendingMeetings": "Semua rapat",
    "AllMeetings": "Tidak ada rapat yang dapat dihadiri saat ini",
    "noMeetings": "Belum dimulai",
    "NotStarted": "Penyelenggara",
    "Organizer": "Tanggal & Waktu",
    "MeetingDateTime": "Lokasi",
    "MeetingLocation": "Topik rapat",
    "MeetingSubject": "Orang yang diundang",
    "Invited": "Orang yang diterima",
    "PeopleAccepted": "Edit rapat",
    "EditMeeting": "Batalkan rapat",
    "CancelMeeting": "Mulai/Edit rapat",
    "InitiateEditMeeting": "Subjek",
    "Subject": "Subjek",
    "Presenter": "Presenter :",
    "DateTime": "Tanggal & Waktu",
    "TimeAndZone": "Zona Waktu",
    "Attendees": "Peserta",
    "Addrequiredattendees": "Tambah peserta yang dibutuhkan",
    "SelectRooms": "Pilih Ruangan",
    "Reminder": "Pengingat",
    "Remindbeforestart": "Ingatkan sebelum mulai",
    "Confirm": "Konfirmasi",
    "topic": "Subjek :",
    "topicplace": "Judul rapat baru :",
    "speaker": "Presenter :",
    "speakerplace": "Harap masukkan informasi presenter",
    "DateAndTime": "Tanggal & Waktu :",
    "TimeZone": "Zona Waktu",
    "EndDate": "Tanggal akhir",
    "Rooms": "Ruang :",
    "Notes": "Catatan :",
    "MeetingRoomApproval": "Persetujuan ruang rapat",
    "PendingApproval": "Menunggu persetujuan",
    "Approved": "Disetujui",
    "nopendingapprovals": "Tidak ada persetujuan yang tertunda",
    "Applicant": "Pemohon",
    "UsageTime": "Waktu penggunaan",
    "ApprovalResult": "Hasil persetujuan",
    "ApprovalComments": "Komentar persetujuan",
    "Approve": "Setujui",
    "Reject": "Tolak",
    "Search": "Cari",
    "Filter": "Saring",
    "scanTheQRCodeToSignIn": "Pindai kode QR untuk mendaftar"
  },
  "NPS": {
    "Relay": "Relay",
    "RelaySettings": "Pengaturan Relay",
    "DevicePower": "Kontrol Daya Perangkat",
    "DeviceElevation": "Kontrol Elevasi",
    "LinageWithNPSPower": "Keterkaitan dengan Daya NPS",
    "PresentationSwitch": "Saklar Presentasi",
    "Duplicate": "Duplikat",
    "LinkagewithNPSPowe": "Keterkaitan dengan Daya NPS",
    "npsTooltip": "Perangkat USB hanya dapat dipanggil oleh host PC yang terhubung ke HDMI OUT 1.",
    "nmpTooltip": "Klik tombol 'Duplikat' untuk mencerminkan konten layar di layar lain, menyinkronkan tampilan di beberapa layar."
  },
  "textTemplate": {
    "template2513": "Penyiaran Darurat Kebakaran",
    "template2514": "Harap evakuasi melalui pintu keluar darurat dan pintu keluar kebakaran ke tempat aman sesuai dengan rencana pelarian kebakaran.",
    "moreTemplate": "Batas template tercapai",
    "add": "Tambahkan",
    "SetTemplate": "Atur Template",
    "Emergency": "Darurat",
    "General": "Umum",
    "BroadcastDevices": "Perangkat Penyiaran:",
    "selectBroadcastDevices": "Harap pilih perangkat penyiaran",
    "All": "Semua",
    "AddTemplate": "Tambahkan Template",
    "EditTemplate": "Edit Template",
    "deleteTemplage": "Apakah Anda yakin ingin menghapus template yang dipilih?",
    "title": "Hapus Template",
    "selectTemplage": "Harap pilih template!",
    "DeleteCancelled": "Hapus dibatalkan!",
    "DeletedSuccessfully": "Berhasil dihapus!",
    "noData": "Tidak ada template yang dapat digunakan, klik pojok kanan atas untuk menambahkan template.",
    "TemplateTitle": "Judul Template:",
    "BroadcastType": "Jenis Penyiaran:",
    "BroadcastTypeDialog": "Jenis Penyiaran:",
    "selectBroadcastType": "Harap pilih jenis penyiaran",
    "BroadcastDuration": "Durasi Penyiaran:",
    "BroadcastDevice": "Perangkat Penyiaran:",
    "BroadcastContent": "Konten Penyiaran:"
  },
  "common": {
    "mediaTimeStateNotifyErrorTitle": "Kesalahan!",
    "mediaTimeStateNotifyErrorContent": "Layanan streaming Anda telah kedaluwarsa, harap hubungi agen Anda untuk memperbarui tepat waktu.",
    "mediaTimeStateNotifyWarnTitle": "Perhatian!",
    "mediaTimeStateNotifyWarnContent": "Anda saat ini berada dalam status percobaan yang hanya dapat mengirimkan penyiaran dan streaming langsung ke maksimal 3 perangkat terminal.",
    "mediaTimeStateNotifySuccessTitle": "Perpanjangan Berhasil",
    "mediaTimeStateNotifySuccessContent": "Layanan streaming Anda siap digunakan secara normal. Terima kasih.",
    "company": "Nama Perusahaan:",
    "tableAddress": "Alamat:",
    "createTime": "Waktu Pembuatan:",
    "email": "Email:",
    "phone": "Telepon:",
    "Trial": "Percobaan",
    "TrialWorkstation": "Anda saat ini berada dalam status percobaan yang hanya dapat mengirimkan penyiaran dan streaming langsung ke maksimal 3 perangkat terminal.",
    "Normal": "Normal",
    "NormalWorkstation": "Periode validitas layanan streaming Anda dari",
    "to": "ke",
    "Advent": "Akan datang",
    "AdventWorkstationOne": "Layanan streaming Anda akan kedaluwarsa pada",
    "AdventWorkstationTwo": ", harap hubungi agen Anda untuk memperbarui tepat waktu untuk penggunaan normal.",
    "Expired": "Kedaluwarsa",
    "ExpiredWorkstation": "Layanan streaming Anda telah kedaluwarsa, harap hubungi agen Anda untuk memperbarui tepat waktu."
  },
  "route": {
    "dashboard": "Dasbor",
    "i18n": "I18n",
    "Devices": "Perangkat",
    "Broadcast": "Penyiaran",
    "Schedule": "Jadwal",
    "Resources": "Sumber Daya",
    "Live": "Langsung",
    "meetings": "Rapat"
  },
  "navbar": {
    "updates":"Pembaruan terbaru",
    "logOut": "Keluar",
    "screenfull": "Layar penuh",
    "oprofile": "Profil saya",
    "settings": "Pengaturan",
    "language": "Bahasa",
    "BackTianwa": "Kembali ke Tianwa",
    "newUserGuide": "Panduan pengguna baru"
  },
  "feedback": {
    "Feedback": "Umpan Balik",
    "email": "Harap tinggalkan email Anda untuk umpan balik kami.",
    "content": "Selamat datang dan tinggalkan pesan untuk meningkatkan produk kami. Terima kasih atas komentar Anda.",
    "submit": "Kirim",
    "emailNoEmpty": "Email tidak boleh kosong",
    "emailTrueRule": "Harap masukkan format email yang benar",
    "contentNoEmpty": "Konten tidak boleh kosong",
    "feedbackSuccess": "Umpan balik berhasil",
    "feedbackFailed": "Umpan balik gagal",
    "emailNoChinese": "Kotak surat tidak boleh mengandung karakter Cina",
    "emailLength": "Panjang antara 5 hingga 50 karakter",
    "emailSpecialString": "Kotak surat tidak boleh mengandung string khusus"
  },
  "login": {
    checkPasswordTitleTwo: 'Silakan buat kata sandi minimal 6 karakter, termasuk huruf dan angka. Karakter khusus diperbolehkan (tanpa batasan).',
    captcha: 'Kode verifikasi',
    checkPasswordTitle: 'Kata sandi minimal 6 karakter dan tidak boleh hanya angka',
    "title": "SELAMAT DATANG",
    "logIn": "Masuk",
    "consoleLogin": "Masuk Konsol",
    "username": "Nama Pengguna",
    "password": "Kata Sandi",
    "any": "apa saja",
    "thirdparty": "Atau hubungkan dengan",
    "thirdpartyTips": "Tidak dapat disimulasikan secara lokal, harap gabungkan dengan simulasi bisnis Anda sendiri!",
    "placeholder": "[\"Nama Pengguna\",\"Kata Sandi\",\"Kode Verifikasi\"]",
    "userNameTitle": "Nama pengguna salah!",
    "forget": "Lupa?",
    "loginTitle0": "Berhasil masuk!",
    "loginTitle1000": "Nama pengguna atau kata sandi salah!",
    "loginTitle1001": "Nama pengguna dan kata sandi harus diisi!",
    "loginTitle1002": "Kode verifikasi harus diisi!",
    "loginTitle1003": "Status pengguna tidak sah, gagal masuk!",
    "loginTitle1004": "Kesalahan kode verifikasi!",
    "loginTitle1005": "Belum masuk, silakan masuk terlebih dahulu!",
    "loginTitle1006": "Kedua kata sandi tidak cocok!",
    "loginTitleUserName": "Nama pengguna harus diisi!",
    "loginTitlePwd": "Kata sandi harus diisi!",
    "loginTitleVercode": "Kode verifikasi harus diisi!",
    "titleLoginNameFormat": "Akun harus terdiri dari huruf atau kombinasi huruf dan angka.",
    "privacy": "Q-NEX User Privacy Policy",
    "privacyContent": "Agree to",
    "_zh": "中文(简体)",
    "_en": "_English",
    "_ko": "한국어",
    "_zh_ft": "中文(繁體)"
  },
  "home": {
    "btnDevices": "Perangkat",
    "btnRoadcast": "Siaran",
    "btnResources": "Sumber daya",
    "btnLive": "Langsung",
    "meetings": "Pertemuan",
    "todaySchedule": "Jadwal Hari Ini",
    "allSkedules": "Semua Jadwal",
    "details": "Detail",
    "btnStart": "Mulai",
    "titleContent": "Halo! Konsol Q-NEX siap melayani Anda. Ayo mulai!",
    "btnExit": "Keluar"
  },
  "devices": {
    ptzCamera:'Kamera PTZ',
    "start": "MULAI",
    "stop": "BERHENTI",
    "nmpPowerOff_mandatory": "Sedang disiarkan (tidak wajib)",
    "nmpPowerOff_nomandatory": "Sedang disiarkan (tidak wajib). Lanjutkan eksekusi?",
    "nmpsPowerOff_mandatory": "Beberapa NMPs sedang disiarkan (wajib).",
    "nmpsPowerOff_nomandatory": "Beberapa NMPs sedang disiarkan (tidak wajib). Lanjutkan eksekusi?",
    "reset": "Reset",
    "displayedInTheControlArea": "Ditampilkan di pusat kontrol",
    "dragOrder": "Urutan seret",
    "areaSettingTwoNotice": "*Kontrol RS232, AC dan kontrol jarak jauh ditampilkan di pusat kontrol tergantung pada status ikatan NMP di dasbor.",
    "areaSettingThreeNotice": "*Kontrol CBX ditampilkan di pusat kontrol tergantung pada status ikatan NMP di dasbor.",
    "controlSet": "Pengaturan pusat kontrol",
    "vcbNoLine": "Tidak ada perangkat CBX yang online",
    "vcbNoBound": "Tidak ada perangkat CBX yang terikat",
    "tscNoBound": "RS232 di TSC tidak terikat ke data manapun. Harap beri tahu administrator untuk mengikatnya di dasbor.",
    "light": "Kontrol daya",
    "vcbpower": "Daya",
    "rs232Control": "Kontrol Serial",

    "CBX": {
    "powerSupplyON": "Nyalakan",
    "powerSupplyOFF": "Matikan",
    "lockScreenON": "Kunci aktif",
    "lockScreenOFF": "Kunci nonaktif",
    "childLockON": "Kunci anak aktif",
    "childLockOFF": "Kunci anak nonaktif",
    "energySavingON": "Hemat energi aktif",
    "energySavingOFF": "Hemat energi nonaktif",
    "signalSourceSwitchingON": "OPS",
    "signalSourceSwitchingOFF": "Android",
    "volumeAdjustment": "Speaker",
    "brightAdjustment": "Kecerahan",
    "other": "Fitur lainnya..."
  },

    "InterfaceOne": "Antarmuka Satu",
    "InterfaceTwo": "Antarmuka Dua",
    "abcStyleP": "Maaf! TSC dan (NMP, MBX, NPS, NDP100, NDP500) tidak dapat dipilih bersamaan",
    "masterControl": "utama",
    "powerSupply": "Daya",
    "RecordingControl": "Kontrol perekaman",
    "RecordingControlSystem": "Sistem perekaman kuliah",
    "LiquidCrystal": "Layar LCD Interaktif",
    "projector": "Proyektor",
    "othertype": "Lainnya",
    "lockScreen": "Kunci",
    "childLock": "Kunci anak",
    "energySaving": "Hemat energi",
    "signalSourceSwitching": "Sumber input",
    "volumeAdjustment": "Speaker",
    "brightAdjustment": "Kecerahan",
    "other": "Fitur lainnya",
    "otherFunction": "Fungsi",
    "send": "Kirim",
    "ON": "ON",
    "OFF": "OFF",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "MAGNETICLOCK",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AIR": "AC",
    "titleDevices": "Filter Grup:",
    "content": "Cari",
    "selectALL": "Pilih SEMUA",
    "SelectRecentPage": "Pilih Halaman Saat Ini",
    "controlPanel": "Pusat Kontrol",
    "displayInputSwitch": "Tombol Masukan Tampilan",
    "chooseINPUTSources": "Pilih Sumber INPUT",
    "speakerVolume": "Volume Audio",
    "bass": "Bass",
    "treble": "Tinggi",
    "MICVolume": "Volume MIC",
    "AirConditioning": "AC",
    "model": "Model",
    "setTemp": "Temperatur Set",
    "fanSpeed": "Kecepatan Kipas",
    "bold": "Ayunan",
    "projectionScreen": "Layar Proyeksi",
    "electronicLock": "Kunci Elektrik",
    "electronicLock1": "Kunci Elektrik",
    "selectDevices": "Silakan pilih perangkat atau grup perangkat",
    "isCompelType": "Kontrol perangkat tidak tersedia karena siaran wajib, silakan coba lagi nanti.",
    "mainPower": "Daya Utama",
    "extraPower": "Daya Ekstra",
    "power": "Daya",
    "hdmiBroadcast": "Penyiaran",
    "equipmentState1": "Nyalakan",
    "equipmentState2": "Matikan",
    "equipmentState3": "Offline",
    "main": "Utama",
    "external": "Eksternal",
    "ProjectionScreen": "Layar Proyeksi",
    "UP": "NAIK",
    "DOWN": "TURUN",
    "LOCK": "KUNCI",
    "UNLOCK": "BLOKIR",
    "PleaseDevice": "Silakan pilih perangkat di sebelah kiri",
    "RemoteControl": "Remote Control",
    "Action": "Aksi",
    "Devicefilter": "Filter Perangkat",
    "DeviceStatus": "Status",
    "DeviceType": "Tipe",
    "currentAudioSource": "Sumber audio saat ini",
    "audioSwitching": "Penyingkap output audio"
  },
  "broadcast": {
    "isBoarding": "(Dalam Penyiaran)",
    "last3Days": "3 HARI TERAKHIR",
    "last7Days": "7 HARI TERAKHIR",
    "last30Days": "30 HARI TERAKHIR",
    "historyRecord": "Riwayat",
    "SelectDestination": "1.Pilih Tujuan",
    "BroadcastingConsole": "2.Konsol Penyiaran",
    "Notification": "Pemberitahuan",
    "btnStop": "Berhenti",
    "btnStart": "Mulai",
    "Letters60": "(kurang dari 60 karakter)",
    "Letters300": "(kurang dari 300 karakter)",
    "LastingTime": "Durasi:",
    "Title": "Judul:",
    "Content": "Konten:",
    "Cannotquit": "Penyiaran Wajib",
    "ChooseMedia": "Pilih File Media",
    "Broadcasting": "Penyiaran",
    "dialogTitle": "Sumber Video & Audio",
    "SortBy": "Urutkan berdasarkan",
    "btnBake": "Kembali ke sebelumnya",
    "cancel": "Batal",
    "confirm": "Konfirmasi",
    "save": "Simpan",
    "coxAll": "Semua",
    "PublicCloud": "Penyimpanan Publik",
    "IndividualCloud": "Penyimpanan Pribadi",
    "selFile": "Silakan pilih file atau grup.",
    "StopBroadcast": "Berhenti Penyiaran",
    "StartBroadcasting": "Mulai Penyiaran",
    "StopBroadcasting": "Berhenti Penyiaran",
    "ForceQuit": "Paksa keluar",
    "PleaseMediaFile": "Silakan pilih file media",
    "PleaseDevice": "Silakan pilih perangkat",
    "broadcast_0": "Mulai Penyiaran",
    "broadcast_2500": "Jumlah perangkat yang dapat terhubung dengan Media Server melebihi batas maksimum",
    "broadcast_2501": "Kesalahan file penyiaran",
    "broadcast_2502": "Penyiaran Selesai",
    "broadcast_2503": "Tidak dapat memperoleh informasi dari Media Server",
    "broadcast_2510": "Perhatian! Anda saat ini berada dalam status percobaan, hingga 3 perangkat terminal dapat menerima perintah siaran. Harap periksa jumlah perangkat yang Anda pilih.",
    "broadcast_2018": "Layanan streaming dimatikan",
    "broadcast_2019": "Layanan streaming telah kedaluwarsa",
    "broadcast_2512": "Melebihi batas jumlah template",
    "broadcast_2513": "Penyiaran keadaan darurat kebakaran",
    "broadcast_2514": "Harap evakuasi dari pintu darurat dan pintu keluar kebakaran ke tempat aman sesuai dengan rencana pelarian kebakaran",
    "broadcast_2006": "Perangkat tidak ditemukan",
    "broadcast_2": "Layanan disk tidak normal",
    "broadcast_2515": "Pilih perangkat yang tidak memiliki kemampuan penyiaran",
    "broadcast_2516": "Pilih file yang melebihi resolusi maksimum yang didukung oleh NMP",
    "broadcast_2517": "Pilih file yang melebihi resolusi maksimum yang didukung oleh NDP500",
    "broadcast_Title": "Peringatan penyiaran",
    "broadcast_TitleNDP500": "Peringatan penyiaran NDP500",
    "broadcast_content": "Perangkat mendukung hingga 4K@30FPS, dengan resolusi optimal 1080P@30FPS",
    "broadcast_contentNDP500": "NDP500/600 mendukung hingga 1080P@30FPS, dengan resolusi optimal 720P@30FPS",
    "broadcast_noSupported": "Video yang dipilih berikut ini tidak didukung untuk siaran:",
    "broadcast_noSupportedNDP500": "Video yang dipilih berikut ini tidak didukung untuk siaran pada NDP500/600:"
  },
  "resources": {
    "uploadNameLengthError": "Nama file yang diunggah tidak boleh lebih dari 100 kata!",
    "onUploadFile": "Tidak ada file untuk diunggah",
    "open": "Buka",
    "fold": "Lipatan",
    "close": "Tutup",
    "PublicCloud": "Penyimpanan publik",
    "IndividualCloud": "Penyimpanan pribadi",
    "TransfersHistory": "Riwayat transfer",
    "btnDownload": "Unduh",
    "btnDelete": "Hapus",
    "btnUploadFile": "Unggah file",
    "btnNewFolder": "Folder baru",
    "btnBake": "Kembali ke halaman sebelumnya",
    "coxAll": "Semua",
    "uploadError": "Ukuran file yang diunggah tidak boleh lebih dari 1 GB!",
    "MD5": "Verifikasi MD5",
    "merge": "Menggabungkan",
    "transcoding": "Transcoding",
    "uploadFailed": "Unggah gagal",
    "fileError": "Kesalahan pembacaan file, silakan periksa file",
    "tableName": "Nama",
    "tableSize": "Ukuran",
    "tableType": "Tipe",
    "tableTimeAdded": "Waktu ditambahkan",
    "tableAction": "Aksi",
    "btnRename": "Ganti nama",
    "btnMoveTo": "Pindahkan ke...",
    "ClearAll": "Hapus semua",
    "cancel": "Batalkan",
    "confirm": "Konfirmasi",
    "save": "Simpan",
    "addSuccess": "Berhasil ditambahkan!",
    "addError": "Gagal menambahkan!",
    "editSuccess": "Berhasil diedit!",
    "editError": "Gagal mengedit!",
    "delSuccess": "Penghapusan Berhasil!",
    "delError": "Gagal Menghapus!",
    "diskError3000": "Ukuran ruang total melebihi batas, operasi gagal!",
    "diskError3001": "Jumlah ruang publik yang digunakan melebihi batas, operasi gagal!",
    "diskError3002": "Jumlah ruang pribadi yang digunakan melebihi batas, operasi gagal!",
    "diskError3003": "Data tidak ditemukan, harap periksa apakah server media terhubung!",
    "diskError3004": "Nama folder sudah ada!",
    "diskError3005": "Gagal mengambil folder!",
    "diskError3006": "Tidak bisa membuat lebih dari 99 folder pada level yang sama!",
    "diskError3007": "Nama file yang sama ada dan modifikasi gagal!",
    "diskError3008": "Nama folder yang sama ada dan modifikasi gagal!",
    "diskError3009": "File melebihi ruang yang tersisa dan unggahan gagal!",
    "diskError3010": "Gagal mengunggah!",
    "diskError3011": "Verifikasi file gagal, harap unggah file lagi!",
    "diskError3012": "Gagal mendapatkan alamat cloud pribadi, operasi gagal!",
    "diskError3013": "Kombinasi file yang lebih dari 100MB tidak dapat dilakukan, file besar harap unduh terpisah!",
    "diskError3014": "Kompresi gagal, harap pilih file untuk diunduh lagi!",
    "diskError3015": "Anda memerlukan izin untuk melakukan tindakan ini",
    "downloadError": "Gagal mengunduh!",
    "mobileError": "Gagal memindahkan!",
    "root": "Semua file",
    "Name": "Nama",
    "Size": "Ukuran",
    "Type": "Tipe",
    "uploadFile": "Unggah file",
    "newFolder": "Folder baru",
    "tableTime": "Waktu",
    "permission": "Izin tidak mencukupi!",
    "notifyTitle": "Pemberitahuan",
    "notifyContent": "Pengguna tidak memiliki izin yang cukup untuk mengaksesnya!",
    "sortFileName": "Nama file",
    "sortTime": "Waktu",
    "sortSize": "Ukuran",
    "sortType": "Tipe",
    "moveTo": "Pindahkan ke",
    "test": "Baru",
    "delTitle": "Hapus?",
    "delTitleContent": "Konten yang dipilih akan dihapus dari basis data. Operasi ini tidak dapat dibatalkan. Apakah Anda yakin ingin melanjutkan?",
    "delCancelButton": "Batal",
    "delConfirmButton": "Konfirmasi"
  },
  "userMge": {
    "userName": "Nama pengguna:",
    "jobNumber": "ID Karyawan:",
    "email": "Email:",
    "phone": "Telepon:",
    "group": "Grup:",
    "oldPassword": "Kata sandi lama:",
    "newPassword": "Kata sandi baru:",
    "confirmNewPassword": "Konfirmasi kata sandi baru:",
    "btnSave": "Simpan perubahan",
    "titleChangePassword": "Ganti kata sandi",
    "titleMyProfile": "Profil saya",
    "name": "Nama panggilan:",
    "error1400": "Akun (kustom) sudah ada, operasi gagal!",
    "error1401": "Akun (dibuat sistem) sudah ada, operasi gagal!",
    "error1402": "Grup tidak ada, impor gagal!",
    "error1403": "Kesalahan data",
    "error1404": "Izin tidak cukup",
    "selUser": "Silakan pilih pengguna!",
    "error1405": "Gagal mendapatkan peran",
    "error1406": "Format data informasi pengguna yang diimpor salah",
    "error1407": "Email sudah ada dan operasi gagal.",
    "error1408": "Telepon sudah ada dan operasi gagal.",
    "editSuccess": "Berhasil disimpan!",
    "ChangePassword": "Ganti kata sandi",
    "UserPrivacyAgreement": "Kebijakan privasi pengguna"
  },
  "information": {
    "_2602": "Perangkat offline",
    "_2603": "Penyiaran gagal",
    "_2604": "Penyiaran terputus",
    "_2605": "Ruang penyimpanan penuh",
    "_2606": "beberapa menit yang lalu",
    "_2607": "beberapa jam yang lalu",
    "_2609": "gagal, silakan ",
    "_2609_a": "klik di sini ",
    "_2609_time": "untuk menanganinya tepat waktu",
    "userType": "Administrator",
    "unreadNoticeFirst": "Baca pemberitahuan terlebih dahulu",
    "sortByTime": "Urutkan berdasarkan waktu",
    "coxRead_1": "Sudah dibaca",
    "coxRead_0": "Belum dibaca",
    "allCoxRead": "Tandai semua sebagai dibaca",
    "load": "Memuat...",
    "noData": "Tidak ada data lagi",
    "viewALLMessages": "Lihat SEMUA pesan"
  },
  "input": {
    "select": "Silakan pilih",
    "thisField": "Kolom ini harus diisi.",
    "titleShooleNub60": "kurang dari 60 karakter",
    "titleShooleNub300": "kurang dari 300 karakter",
    "Offline": "Offline"
  },
  "schedule": {
    "OnlyManual": "Hanya Manual",
    "runStartNow": "Jalankan Tugas",
    "runStopNow": "Hentikan Tugas",
    "tackExecutionStart": "Tugas sedang berjalan",
    "tackExecutionStop": "Pelaksanaan Tugas Dihentikan",
    "dehumidification": "Pengeringan udara",
    "airSupply": "Pasokan udara",
    "masterControl": "utama:",
    "powerSupply": "Daya",
    "lockScreen": "Kunci",
    "RecordingControl": "Kontrol Perekaman",
    "RecordingControlSystem": "Sistem Rekaman Kuliah",
    "LiquidCrystal": "Layar LCD Interaktif",
    "projector": "Proyektor",
    "othertype": "Lainnya",
    "childLock": "Kunci Anak",
    "energySaving": "Hemat energi",
    "signalSourceSwitching": "Sumber Masukan",
    "other": "Fitur lainnya:",
    "otherFunction": "Fungsi",
    "send": "Kirim",
    "ON": "NYALA",
    "OFF": "MATI",
    "btnAddSchedule": "Pulihkan",
    "EditSchedulelist": "Edit Penjadwal",
    "AddSchedulelist": "Tambah Penjadwal",
    "RestoreSchedulelist": "Pulihkan",
    "btn": "Batal",
    "btnNewList": "Penjadwal Baru",
    "ListName": "Nama",
    "Cannotquit": "Wajib",
    "NOCannotquit": "TIDAK",
    "ListValidityPeriod": "Periode Validitas",
    "ListDescription": "Deskripsi",
    "currentSchedule": "Daftar Penjadwal",
    "historySchedule": "Daftar Riwayat",
    "selectTime": "Waktu",
    "selectTimeTable": "Waktu",
    "taskType": "Jenis Tugas",
    "selectBroadcasting": "Penyiaran",
    "selectDeviveControl": "Kontrol Perangkat",
    "newSchedule": "Tugas Baru",
    "newChecklist": "Daftar Periksa Baru",
    "titleStatus": "Status",
    "titleType": "Jenis",
    "titleStartTime": "Waktu Mulai",
    "titleEndTime": "Waktu Selesai",
    "titleRepeat": "Ulangi",
    "titleName": "Nama",
    "titleAction": "Tindakan",
    "tableEnabled": "Diaktifkan",
    "tablePaused": "Jeda",
    "tableEdit": "Edit",
    "tableDelete": "Hapus",
    "tableVolumeEdit": "Volume Penyiaran",
    "tableBroadcastTitle": "Judul",
    "tableBroadcastContent": "Konten",
    "tableBroadcastList": "Daftar",
    "tableBroadcast": "Wajib",
    "btnRemoveCompletely": "Hapus sepenuhnya",
    "btnEnabled": "Tugas yang diaktifkan",
    "btnPaused": "Nonaktifkan tugas",
    "btnDelete": "Hapus",
    "repeat0": "SEN",
    "repeat1": "SEL",
    "repeat2": "RAB",
    "repeat3": "KAM",
    "repeat4": "JUM",
    "repeat5": "SAB",
    "repeat6": "MIN",
    "dialogTitleAdd": "Tugas kontrol perangkat baru",
    "dialogTitleEdit": "Edit tugas kontrol perangkat",
    "newBroadcastingSchedule": "Tugas siaran baru",
    "editBroadcastingSchedule": "Edit tugas siaran",
    "chooseDevice": "Pilih perangkat",
    "timeSetting": "Pengaturan waktu",
    "controlBroadcasting": "Opsi siaran",
    "controlOption": "Opsi kontrol",
    "scheduleName": "Nama tugas:",
    "destination": "Tujuan",
    "timeTilte": "Waktu",
    "repeatTitle": "Ulangi",
    "dialogRepeat0": "SEN",
    "dialogRepeat1": "SEL",
    "dialogRepeat2": "RAB",
    "dialogRepeat3": "KAM",
    "dialogRepeat4": "JUM",
    "dialogRepeat5": "SAB",
    "dialogRepeat6": "MIN",
    "dialogOnceType": "Sekali",
    "dialogRepeatType": "Ulangi",
    "Manual": "Manual",
    "ManualContent": "Anda dapat menjalankan tugas ini secara manual setelah selesai pengaturan.",
    "mainPower": "Daya utama",
    "powerControl": "Kontrol daya",
    "tableDisplayInputSwitch": "Saklar input tampilan",
    "tableAirConditioning": "AC",
    "tableProjectionScreen": "Layar proyeksi",
    "tableElectronicLock": "Kunci listrik",
    "interactiveFlatPanel": "Panel datar interaktif",
    "displayInputSwitch": "Saklar input tampilan",
    "speakerVolume": "Volume audio",
    "MICVolume": "Volume MIC",
    "ProjectionScreen": "Layar proyeksi",
    "ElectronicLock": "Kunci listrik",
    "AirConditioning": "AC",
    "AirConditioningPower": "Daya",
    "AirConditioningModel": "Model",
    "AirConditioningTEMP": "Temperatur",
    "AirConditioningFanSpeed": "Kecepatan kipas",
    "OPEN": "Buka",
    "CLOSE": "Tutup",
    "UP": "Atas",
    "DOWN": "Bawah",
    "PowerOFF": "Matikan",
    "PowerON": "Nyalakan",
    "ModelAuto": "Auto",
    "ModelCool": "Dingin",
    "ModelHeat": "Panas",
    "ModelAir": "Sisi udara",
    "TEMPLow": "Rendah",
    "TEMPMiddle": "Sedang",
    "TEMPHigh": "Tinggi",
    "btnSave": "Simpan",
    "btnNext": "BERIKUTNYA",
    "StartTime": "Waktu mulai",
    "StopTime": "Waktu berhenti",
    "Mandatory": "Wajib",
    "Video": "Video & Audio",
    "Notification": "Pemberitahuan",
    "btnFile": "Pilih file media",
    "LastingTime": "Waktu berlangsung",
    "textTitle": "Judul",
    "textContent": "Konten",
    "textTitleLetters": "Kurang dari 60 huruf",
    "textContentLetters": "Kurang dari 320 huruf",
    "CannotquitYES": "YA",
    "CannotquitNo": "Tidak",
    "YES": "Apakah Anda yakin ingin menghapus penjadwal ini?",
    "No": "Penjadwal yang dihapus akan dipindahkan ke daftar riwayat dan dapat dipulihkan",
    "delTitleContent": "Hapus penjadwal?",
    "delTitleListContent": "Menghapus penjadwal akan menghapus tugas terkait, harap konfirmasi.",
    "deleListTitle": "Apakah Anda yakin ingin menghapus penjadwal ini?",
    "delTitleListContent1": "Hapus?",
    "deleListTitle1": "Konfirmasi",
    "delTitle": "SEMUA",
    "btnConfirm": "Siaran",
    "coxAll": "Kontrol perangkat",
    "coxBroadcasting": "YA",
    "coxDeviveControl": "TIDAK",
    "rdMandatory": "Tanggal mulai",
    "noRdMandatory": "Tanggal selesai",
    "startDate": "-",
    "endedDate": "Jenis",
    "or": "Pilih waktu",
    "broadcastingType": "Pilih tanggal",
    "ChooseTime": "Penjadwal baru",
    "ChooseDate": "Edit penjadwal",
    "newScheduleList": "Nama",
    "editScheduleList": "Periode berlaku",
    "listName": "Deskripsi",
    "listValidityPeriod": "Batal",
    "listDescription": "Konfirmasi",
    "cancel": "Batal",
    "confirm": "Konfirmasi",
    "save": "Simpan",
    "addSuccess": "Berhasil ditambahkan!",
    "addError": "Gagal menambahkan!",
    "editSuccess": "Berhasil diedit!",
    "editError": "Gagal mengedit!",
    "delSuccess": "Berhasil dihapus!",
    "delError": "Gagal menghapus!",
    "restoreSuccess": "Daftar penjadwalan berhasil dipulihkan",
    "restoreError": "Pemulihan daftar penjadwalan gagal",
    "restoreTitleContent": "Waktu ini bertentangan dengan waktu dalam daftar, silakan pilih lagi",
    "Enabled": "Diaktifkan",
    "Paused": "Dijeda",
    "Title": "Judul:",
    "Content": "Konten:",
    "errorScheduleNameRequired": "Nama tugas harus diisi",
    "errorDeviceRequired": "Harap pilih perangkat target",
    "deleTitle": "Apakah Anda yakin ingin menghapus tugas ini?",
    "loopList": "Daftar putar",
    "errorPleaseDateRange": "Harap pilih rentang tanggal",
    "addError_2009": "Nama penjadwal duplikat",
    "conflicts": "Waktu tugas bertentangan dengan tugas berikutnya:",
    "Pleaseagain": "Silakan masukkan lagi",
    "errorScheduleName": "Nama tugas",
    "errorListName": "Nama penjadwal",
    "today": "Hari ini",
    "yesterday": "Kemarin",
    "thisWeek": "Minggu ini",
    "lastWeek": "Minggu lalu",
    "lastMonth": "Bulan lalu",
    "thisMonth": "Bulan ini",
    "times": "Kali",
    "TimeConflicts": "Konflik waktu",
    "editError_2006": "Perangkat tidak ditemukan",
    "editError_2010": "Nama tugas duplikat",
    "editError_2100": "Tugas telah kedaluwarsa, tidak dapat dimulai.",
    "ListTimeExpired": "Waktu penjadwal telah kedaluwarsa, silakan pilih lagi",
    "TimeExpired": "Waktu kedaluwarsa",
    "ControlOption": "Opsi kontrol hilang",
    "Pleaseleastone": "Silakan pilih setidaknya satu opsi kontrol",
    "Enter": "Masukkan",
    "TitleFilled": "Judul harus diisi",
    "ContentFilled": "Konten harus diisi",
    "PleaseMediaFile": "Harap pilih file media",
    "PleaseSchedule": "Harap pilih tugas",
    "delTitleScheduleContent": "Tugas yang dihapus tidak dapat dipulihkan.",
    "deleTitleSchedule": "Apakah Anda yakin ingin menghapus tugas ini?",
    "deleteScheduleTitle": "Harap pilih tugas untuk dihapus",
    "PleaseFillColumn": "Harap isi nama penjadwal",
    "PleaseDate": "Harap pilih tanggal",
    "Previous": "Sebelumnya",
    "RemoteControl": "Kontrol jarak jauh",
    "taskhasexpired": "Tugas ini telah kedaluwarsa, harap hubungi pembuat untuk memperbarui waktu",
    "execute": "Eksekusi",
    "broadcastingList": "Daftar siaran",
    "volumeSuccess": "Volume berhasil disetel",
    "volumeFailed": "Gagal menyetel volume"
  },
  "live": {
    "StreamingRoom": "Ruang Streaming",
    "btnAddNewRoom": "Tambahkan Ruang Baru",
    "Steaming": "Streaming",
    "Creater": "host:",
    "Address": "Alamat RTMP:",
    "StreamingURL": "URL Streaming Langsung:",
    "DestinationNMP": "Pilih Tujuan NMP:",
    "stop": "BERHENTI",
    "stat": "MULAI",
    "btnCope": "Klik untuk MENSALIN",
    "QRcode": "KODE QR",
    "Refresh": "Segarkan",
    "AddNewRoomTitle": "Tambahkan ruang streaming baru",
    "editNewRoomTitle": "Edit ruang streaming",
    "roomName": "Nama ruang:",
    "cancel": "Batal",
    "confirm": "Konfirmasi",
    "save": "Simpan",
    "delTitleContent": "Apakah Anda yakin ingin menghapus jadwal ini?",
    "delTitle": "Hapus?",
    "delCancelButton": "Batal",
    "delConfirmButton": "Konfirmasi",
    "addSuccess": "Berhasil ditambahkan!",
    "addError": "Gagal menambahkan!",
    "editSuccess": "Berhasil diedit!",
    "editError": "Gagal mengedit!",
    "delSuccess": "Berhasil dihapus!",
    "delError": "Gagal menghapus!",
    "Stopstreaming": "Berhenti streaming",
    "Startstreaming": "Mulai streaming",
    "error2504": "Tidak dapat mendapatkan alamat streaming langsung dari server media",
    "error2505": "Nama ruang streaming duplikat",
    "error2506": "Perangkat telah digunakan oleh sinyal streaming lain",
    "error1900": "Parameter yang diakses kosong",
    "error2503": "Tidak dapat mendapatkan informasi server media",
    "error2507": "Alamat streaming langsung duplikat",
    "copySuccess": "Konten telah disalin ke clipboard.",
    "copyError": "Browser tidak mendukung penyalinan otomatis",
    "flashControl": "Flash tidak terinstal atau diaktifkan. Silakan coba lagi setelah menginstal atau mengaktifkan Flash.",
    "liveStreaming": "Sumber streaming langsung tidak ditemukan.",
    "btnflash": "Instal/aktifkan",
    "serverAddress": "Alamat server",
    "addressKey": "Kunci:",
    "watchingAddress": "Alamat tontonan",
    "audioOnly": "Hanya audio",
    "enterTheKey": "Kunci harus diisi."
  },
  "guidepages": {
    "next": "Perangkat kontrol berikutnya",
    "next1": "Coba kontrol berikutnya",
    "next2": "Siaran berikutnya",
    "next3": "Mulai siaran berikutnya",
    "next4": "Berhenti siaran berikutnya",
    "next5": "Siaran teks berikutnya",
    "next6": "Pengaturan tugas berikutnya",
    "next7": "Tambahkan tugas baru berikutnya",
    "next8": "Daftar riwayat berikutnya",
    "next9": "Penyimpanan cloud berikutnya",
    "next10": "Streaming langsung berikutnya",
    "next11": "Pengaturan streaming langsung berikutnya",
    "exit": "Keluar",
    "guideContent": "Konten panduan",
    "btnHomepage": "Halaman utama",
    "btnDevices": "Perangkat",
    "btnBroadcast": "Siaran",
    "btnSchedule": "Jadwal",
    "btnResources": "Sumber daya",
    "btnStreaming": "Langsung",
    "btnPrevious": "Sebelumnya"
  },
  "privacy": {
    "PrivacyPolicy": "Q-NEX Privacy Policy",
    "Byusing": "By using the Q-NEX service, you are trusting us to process your information. We understand that this responsibility is important, so we have been committed to protecting your information and giving you control.",
    "whatinformation": "This Privacy Policy is designed to help you understand what information we collect, why it is collected, and how you manage your information.",
    "EffectiveDate": "Effective Date: January 1, 2020",
    "title1": "Q-NEX Respects Your Privacy",
    "title1Respects1": "Returnstar Interactive Technology Group Co.,Ltd. and its sub-brand (collectively “Q-NEX”, “we” or “us”) respect your privacy and understand that the processing and security of your personal data is important to you. Please review the full Privacy Policy below for more complete details on how we collect, use, share, and protect your personal data, as well as the choices you have regarding our use and sharing of your personal data, along with other important considerations.",
    "title1Respects2": "This Privacy Policy explains Q-NEX’s practices regarding the processing (such as the collection, use, storage, copy or disclosure) of your personal data received: (i) through our website https://www.qnextech.com (“Website”), email, and other written or in person communications; (ii) in the context of all our commercial relations with customers, end-users, dealers, distributors, suppliers, contractors, agents or representatives; and (iii) in the normal course of any other potential business relationship. We commit to comply with our obligations under all applicable Privacy and Data Protection Laws, as described below, including but not limited to the Provisions on Protection of Personal Information of Telecommunications and Internet Users, and to respect your rights whenever we are processing your personal data.",
    "title2": "Privacy and Data Protection",
    "title2Respects1": "“Personal Data” means any information that identifies, or can be used to identify, an individual.",
    "title2Respects2": "“Privacy and Data Protection Laws” means any and/or all laws, rules, directives and regulations, on any local, provincial, state, federal or national level within and outside the People's Republic of China, pertaining to data privacy, data security and/or the protection of Personal Data. Among them, laws and regulations outside China include but not limited to: (a) the General Data Protection Regulation (GDPR) and each European Union Member States’ national implementation thereof; (b) the Australian Privacy Act 1988 (Cth) and the Australian Privacy Amendment (Enhancing Privacy Protection Act) (2012); (c) the Belgian Privacy Law of 8 December 1992; (d) the Canadian Personal Information Protection and Electronic Documents Act, SC 2000, c 5 (PIPEDA); (e) the Personal Data Protection Act 2012 of Singapore (PDPA); (f) additional privacy and data protection laws applicable to a data subject’s location; and (g) any successor legislation or regulations applicable thereto.",
    "title3": "When Do We Collect Your Personal Data?",
    "title3Respects1": "Q-NEX may collect your personal data when you communicate with us by phone, e-mail, the Website or otherwise, in the context of:",
    "title3a": "Browsing our Website or visiting our social media sites;",
    "title3b": "Corresponding with Q-NEX;",
    "title3c": "Visiting one of our offices, events or facilities;",
    "title3d": "Registering for and/or participating in our conferences, events, training or other activities;",
    "title3e": "Requesting information, support, service, materials, assistance or other inquiries;",
    "title3f": "Subscribing to a newsletter or other mailing list;",
    "title3g": "Exchanging business cards;",
    "title3h": "Completing Website contact forms, questionnaires, surveys, or contest entry forms or otherwise participating in these activities;",
    "title3i": "Engaging in commercial relationships or other collaboration;",
    "title3j": "Ordering or registering Q-NEX products;",
    "title3k": "Creating or registering an account;",
    "title3l": "Uploading or downloading files;",
    "title3m": "Verification of your identity as a data subject; or",
    "title3n": "Using Q-NEX products that are connected to the Internet, including mobile apps, cloudware, and certain hardware devices.",
    "title4": "Which Types of Personal Data are Processed by Us?",
    "title4Respects1": "Q-NEX may process the following personal data:",
    "title4a": "Name, surname, title, company, email address, phone number (mobile and landline), address, signature and other contact information;",
    "title4b": "IP addresses;",
    "title4c": "Location data;",
    "title4d": "Cookie ID;",
    "title4e": "Language;",
    "title4f": "Personal preferences regarding communications and/or products and services;",
    "title4g": "Financial details (e.g. payment information, bank account number, and credit information);",
    "title4h": "Personal data regarding projects using Q-NEX products and services;",
    "title4i": "Personal data provided in your submissions, responses and feedback;",
    "title4j": "Personal data regarding your interactions with Q-NEX, including your use of the Website and of Q-NEX’s products or services;",
    "title4k": "Social media data, images, photos, and camera footage; and",
    "title4l": "Any other personal data provided by you or by your authorized Q-NEX dealer or service provider.",
    "title4Respects2": "For the avoidance of doubt, Q-NEX does not collect any sensitive personal data, such as racial or ethnic origin; political opinions; religious or philosophical beliefs; genetic characteristics; health information; sexual preferences; information about children; criminal convictions; or biometric data, and we explicitly ask that you not provide us with such data in your responses or feedback to us.",
    "title5": "How Do We Use Your Personal Data?",
    "title5Respects1": "In order to better manage our own business needs and to better communicate with you, we may collect, analyze, use and otherwise process your personal data for the following purposes:",
    "title5a": "To respond to your inquiries, questions and other requests;",
    "title5b": "To optimize and manage the quality and content of our Website, including the ability to personalize and secure your Website experience;",
    "title5c": "To create and maintain your website, customer and product accounts and registrations;",
    "title5d": "To provide you with marketing, advertising, promotions, programs, offers and other opportunities; including newsletters, information on products and services, subscriptions, training, updates and direct marketing, which may be targeted, based on your communication preferences;",
    "title5e": "To conduct customer satisfaction studies, surveys and other market research;",
    "title5f": "To manage our events and activities, and invite you to events;",
    "title5g": "To register visitors to our offices, facilities and events;",
    "title5h": "To create promotional materials, including videos, photos, articles, case studies, newsletters and other materials regarding projects or events;",
    "title5i": "To provide products, services, training, technical support, customer service and other assistance;",
    "title5j": "To manage and perform our agreements and obligations;",
    "title5k": "To respond to and follow up on business leads, opportunities, and contacts;",
    "title5l": "To process payments, orders, invoicing, returns, collection and other requests;",
    "title5m": "To provide pricing, quotations and custom configurations of our products and services;",
    "title5n": "To grant you access to our software, training, technical information and other proprietary content;",
    "title5o": "To evaluate, troubleshoot, analyze and improve the use, functionality, features, and performance of our products, services, training, technical support and customer service;",
    "title5p": "To gather, analyze and maintain configuration and backup data regarding our products and services;",
    "title5q": "To facilitate planning, analytics, forecasting and reporting regarding our products and services;",
    "title5r": "To use for our internal business operations and processes, including business and financial recordkeeping, data management and business continuity; and",
    "title5s": "To meet our legal and regulatory obligations.",
    "title6": "Which Legal Basis Applies To Our Processing Of Your Personal Data?",
    "title6Respects1": "The following legal grounds might apply to the processing of your personal data for the purposes mentioned above:",
    "title6a": "Processing is necessary for the performance of your agreement with us or in order to take all pre-contractual steps;",
    "title6b": "Processing takes place based upon our legitimate interest (comply with obligations, maintain business records, fraud prevention, network and information security, etc.). When carrying out this type of processing, we strive to strike a balance between this legitimate interest and respect for your privacy;",
    "title6c": "You have given your consent to the processing (e.g. in case of direct marketing, for the processing of analytic cookies and for data transfers to third parties);",
    "title6d": "In order to comply with our legal obligations (such as tax administration and record retention); or",
    "title6e": "In very exceptional circumstances to protect your vital interest or that of someone else.",
    "titel7": "To Whom Do We Disclose Your Personal Data?",
    "title7Respects1": "Q-NEX may disclose your personal data to yourself, to Q-NEX’s affiliates or to third parties, such as payment providers, software providers, cloud partners, transport partners, financial institutions, insurance companies, legal services, or certain other service providers or partners that Q-NEX has a strategic relationship with, in order to fulfill our relationship with you in the most effective way.",
    "title7Respects2": "Q-NEX will not disclose to third parties any personal data you submit for purposes other than those described in this Privacy Policy. If, in the future, we intend to disclose your personal data to third parties for any purpose other than those described in this Privacy Policy we shall inform you thereof in advance and ask your consent if required.",
    "title7Respects3": "Notwithstanding the foregoing, Q-NEX will disclose your personal data to a third party (such as competent authorities) if required to do so by law, during a legal proceeding, or if, in good faith, Q-NEX believes that such action is necessary to comply with certain laws, rules or regulations.",
    "titel8": "Which Guarantees Do We Provide in Case of International Data Transfers?",
    "title8Respects1": "Q-NEX is a global company and we may transfer your information to Q-NEX affiliates, representatives or third party contractors who represent us worldwide. Each affiliate, representative, or third party contractor works closely with Q-NEX, and any transfer of personal data between these associated entities will comply with applicable Privacy and Data Protection Laws.",
    "title8Respects2": "If any transfer of the personal data of residents of the European Economic Area (EEA) is made to a person or entity located in a country outside of the EEA, that is not recognized as providing an adequate level of protection, we will provide for increased information security and appropriate contractual provisions to strengthen data protection. To ensure that any such transfers of the personal data of EEA residents are compliant with the applicable Privacy and Data Protection Laws, we will either (i) conclude a data transfer agreement, based upon the EU model agreements, (ii) adopt binding corporate rules, (iii) rely on legally determined exceptions (such as requesting your explicit consent) or (iv) adopt other mechanisms which have been deemed to provide for the adequate protection of your personal data.",
    "titel9": "How Do We Secure Your Personal Data?",
    "title9Respects1": "We use a variety of security technologies and precautions, such as the Secure Socket Layer (SSL) protocol (encryption), to help protect your personal data from loss, theft, misuse and unauthorized access, in accordance with industry standards. To protect any personal data stored on Q-NEX servers or cloud-based storage, we regularly monitor our systems for vulnerabilities or attacks, and implement up to date information security measures.",
    "title9Respects2": "Access to personal data that is processed by Q-NEX is limited only to those of its employees, contractors and affiliated organizations that need to know that information in order to process it on Q-NEX’s behalf, in accordance with this Privacy Policy, and that have agreed not to disclose it to others.",
    "titel10": "How Long Do We Retain Your Personal Data?",
    "title10Respects1": "Unless a longer retention period is required by law, Q-NEX will retain your personal data for as long as needed to fulfil the relevant purposes described in this Privacy Policy.",
    "titel11": "Use of Cookies",
    "title11Respects1": "Q-NEX uses cookies on our Website, both to enable the site to work properly, and to enhance your experience while visiting our Website. Cookie file(s), which are stored on the hard drive of your computer, enable us to obtain information about your usage of our Website, and to measure and improve the performance of our Website. Cookies enable you to store your preferences, in order to enable our Website to recognize these preferences when you browse our Website.",
    "title11Respects2": "You may refuse to accept cookies by activating the setting on your browser which allows you to refuse cookies. However, if you select this setting you may not be able to access certain sections or features of our Website. Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies to your computer whenever you log on to our Website.",
    "title11Respects3": "When you visit our Website for the first time you will be provided with a link to this cookie policy and will have the opportunity to change your browser settings to refuse cookies. By continuing to browse our website without changing your settings, you agree to our use of cookies as explained in this policy.",
    "title11Respects4GoogleAnalytics": "Google Analytics.",
    "title11Respects4": "We use industry standard web analytics to track visits to our sites, namely those provided by Google Analytics. The information generated by the cookies about your use of our Website (including your IP address) will be transmitted to and stored by Google Analytics on their servers and is handled in accordance with Google’s Privacy Policy which can be accessed at the following link: https://policies.google.com/privacy.",
    "titel12": "Third Party Links on our Website",
    "title12Respects1": "The Website contains links to other websites. Q-NEX is not responsible for the privacy policy of other websites, or the manner in which they store, use or distribute information. Q-NEX encourages you to review the privacy policy of any website you may visit.",
    "titel13": "Children’s Information",
    "title13Respects1": "Q-NEX’s Website is not intended for use by children, and its products and services are not sold to children. In accordance with the Children’s Online Privacy Protection Act, we do not collect or maintain information from persons we know are under 18, and no part of the Website is designed to attract anyone under age 18.",
    "titel14": "What Are Your Rights and How Can You Exercise Them?",
    "title14Respects1": "If you are a natural person, you have the right at all times to be informed about the personal data we process about you, and to the extent authorized under the applicable Privacy and Data Protection Laws, to request access, modification, limitation of processing, transfer or deletion of personal data, or to object to the processing of your personal data, subject to the exceptions within the applicable Privacy and Data Protection Laws.",
    "title14Respects2": "If processing is based solely on your consent, you also have the right to revoke your consent at any time, without prejudice to the lawfulness of processing prior to revocation.",
    "title14Respects3": "Through the contact options listed below, you can exercise the above rights regarding the processing of your personal data by Q-NEX, except in cases where this would require a disproportionate effort on the part of Q-NEX.",
    "title14Respects4": "Please feel free to use the contact information listed below if you have any additional concerns regarding your personal data or your exercise of the above rights, and we will do our best to assist you.",
    "title14Respects5": "If you contact us to exercise one of your rights under the applicable Privacy and Data Protection Laws, we will reply within one (1) month. In certain exceptional circumstances, we may take up to three (3) months to fully respond to you, but in such case we shall inform you why we require additional time to respond in our initial reply.",
    "title14Respects6": "If we are unable to resolve an inquiry or request, where applicable, you may have the right to lodge a complaint with the local data protection authority.",
    "titel15": "Stay Informed of Changes in Our Privacy Policy",
    "title15Respects1": "In a world in which technology and legislation is constantly changing, this Privacy Policy may also change. We invite you to always consult the latest version of this policy, posted at https://www.qnextech.com/legal, and we will inform you of any changes via our Website or other common communication channels.",
    "titel16": "Contact Q-NEX",
    "title16Respects1": "If you have questions and/or comments about this Privacy Policy or the manner in which Q-NEX collects, uses and/or processes your personal data, please contact us:",
    "title16Respects2": "Via e-mail: info@qnextech.com"
    }
}



// WEBPACK FOOTER //
// ./src/lang/id.js